import { render, staticRenderFns } from "./GenericSelect.vue?vue&type=template&id=db152902&lang=pug&"
import script from "./GenericSelect.vue?vue&type=script&lang=ts&"
export * from "./GenericSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports